import classNames from 'classnames'
import type { ComponentChild } from 'preact'

/**
 * A progress bar for indicating the current step in a multi-step process.
 * It is used in the ProductSelectSection component.
 */
export default function ProgressBar({ currentStep, stepsCount, lastStepMarker }: ProgressBarProps) {
  return (
    <div className='flex items-center gap-x-0.5'>
      {Array.from({ length: !!lastStepMarker ? stepsCount - 1 : stepsCount }, (_, i) => {
        const step = i + 1
        return (
          <>
            <span
              className={classNames(
                'fast-transition flex h-5 w-5 shrink-0 items-center justify-center  rounded-full text-sm text-bright-white',
                {
                  'bg-dark-blue-gray': step === currentStep,
                  'bg-logo-lime': step < currentStep,
                  'bg-neutral-gray': step > currentStep
                }
              )}>
              {step}
            </span>
            {step < stepsCount && (
              <hr
                className={classNames(
                  'h-1 w-4 transition-all duration-150 ease-out sm:w-8 md:w-12 xs:w-6',
                  {
                    'bg-logo-lime': step < currentStep,
                    'bg-neutral-gray': step >= currentStep
                  }
                )}
              />
            )}
          </>
        )
      })}
      {lastStepMarker}
    </div>
  )
}

type ProgressBarProps = {
  currentStep: number
  stepsCount: number
  lastStepMarker?: ComponentChild
}
